export const GOAL = 'Mål';
export const ADD_GOAL = 'Tilføj mål...';
export const ADD_GOAL_PLACEHOLDER = 'Beskriv målet, f.eks. hvilket læringsudbytte eleven skal få af kapitlet';
export const DELETE_GOAL = 'Slet mål...';
export const ADD_SUB_GOAL = 'Tilføj delmål';
